import React from 'react';
import { formatUnits } from '../utils/arrivals';
import '../styles/components/ProductSpecs.scss';

/**
 * Ficha técnica del producto (`product.ficha_tecnica`, la envían PromoOpción y Marpico):
 * { material, medidas, capacidad, impresion: { tecnica, area },
 *   empaque: { largo_cm, ancho_cm, alto_cm, peso_bruto_kg, peso_neto_kg,
 *              unidades_caja, unidades_inner, inners_caja, empaque_individual } }
 * Solo se muestran las filas con dato; si no hay ninguna, no se pinta nada.
 */

// 6.8 → "6,8"; 80.5 → "80,5"
const formatDecimal = (n) => String(Math.round(Number(n) * 100) / 100).replace('.', ',');

const boxSize = ({ largo_cm: l, ancho_cm: a, alto_cm: h } = {}) => {
  const dims = [l, a, h].filter((v) => Number(v) > 0);
  return dims.length ? `${dims.map(formatDecimal).join(' x ')} cm` : null;
};

const buildGroups = (specs) => {
  const impresion = specs.impresion || {};
  const empaque = specs.empaque || {};
  const units = (n) => (n ? `${formatUnits(n)} und.` : null);
  const kg = (n) => (n ? `${formatDecimal(n)} kg` : null);

  return [
    {
      title: 'Información básica',
      rows: [
        ['Material', specs.material],
        ['Medidas', specs.medidas],
        ['Capacidad', specs.capacidad],
      ],
    },
    {
      title: 'Información de impresión',
      rows: [
        ['Técnica', impresion.tecnica],
        ['Área de impresión', impresion.area],
      ],
    },
    {
      title: 'Información de empaque',
      rows: [
        ['Medidas de la caja', boxSize(empaque)],
        ['Peso bruto', kg(empaque.peso_bruto_kg)],
        ['Peso neto', kg(empaque.peso_neto_kg)],
        ['Unidades por caja', units(empaque.unidades_caja)],
        ['Unidades por inner', units(empaque.unidades_inner)],
        ['Inners por caja', empaque.inners_caja ? formatUnits(empaque.inners_caja) : null],
        ['Empaque individual', empaque.empaque_individual],
      ],
    },
  ]
    .map((group) => ({ ...group, rows: group.rows.filter(([, value]) => value) }))
    .filter((group) => group.rows.length > 0);
};

const ProductSpecs = ({ specs }) => {
  if (!specs || typeof specs !== 'object') return null;
  const groups = buildGroups(specs);
  if (groups.length === 0) return null;

  return (
    <section className="ProductSpecs" aria-labelledby="ficha-tecnica-title">
      <div className="ProductSpecs__header">
        <h3 id="ficha-tecnica-title" className="ProductSpecs__title">Ficha técnica</h3>
        <p className="ProductSpecs__subtitle">Información suministrada por la bodega.</p>
      </div>
      <div className="ProductSpecs__grid">
        {groups.map((group) => (
          <div key={group.title} className="ProductSpecs__group">
            <h4 className="ProductSpecs__group-title">{group.title}</h4>
            <dl className="ProductSpecs__list">
              {group.rows.map(([label, value]) => (
                <div key={label} className="ProductSpecs__row">
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductSpecs;
